import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { FuseSidebarModule } from '@fuse/components/sidebar/sidebar.module';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AccessComponent } from './access.component';
import { SchedulesDialogComponent } from './dialogs/schedules-dialog/schedules-dialog.component';
import { AddAccessDialogComponent } from './dialogs/add-access-dialog/add-access-dialog.component';
import { EventEmitterService } from './services/event-emitter.service';
import { CopyAccessDialogComponent } from './dialogs/copy-access-dialog/copy-access-dialog.component';

const routes = [
    {
        path     : 'access',
        component: AccessComponent
    }
];

@NgModule({
    declarations: [
        AccessComponent,
        SchedulesDialogComponent,
        AddAccessDialogComponent,
        CopyAccessDialogComponent
    ],
    imports     : [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        MatTabsModule,
        MatTooltipModule,
        MatDialogModule,
        MatInputModule,
        MatRadioModule,

        FuseSidebarModule,
        FuseWidgetModule,

        TranslateModule,

        FuseSharedModule,
        NgxSpinnerModule
    ],
    exports     : [
        AccessComponent
    ],
    providers:[
        EventEmitterService
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class AccessModule
{
}
